import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NewResourceHeader } from "../components/header";
import ShowNotifications from "../components/notifications";
import { axiosPost } from "./common";
import {
  Form,
  SpaceBetween,
  ContentLayout,
  Header,
  Button,
  FormField,
  Input,
  Container
} from '@cloudscape-design/components';

function PostData(state) {
  // convert state.formData to a key=value object
  const data = Object.keys(state.formData).reduce((acc, key) => {
    acc[key] = state.formData[key].value;
    return acc;
  }, {});
  // console.log("Will create new resource: ", data);
  state.setLoading(true);
  axiosPost(state.url, data)
  .then((response) => {
    if (response.data.error !== false) {
      // console.log(response.data.error);
      state.setLoading(false);
      ShowNotifications({
        child: state.url,
        flashbar: state.flashbar,
        header: `Error creating new ${state.resource}:`,
        message: response?.data?.result || "Unknown error",
        type: "error"
      });
    } else {
      ShowNotifications({
        child: state.url,
        flashbar: state.flashbar,
        header: `Created new ${state.resource}:`,
        message: data.name
      });
      state.setLoading(false);
      state.navigate("/" + state.url);
    }
  })
  .catch((error) => {
    // console.log(error);
    state.setLoading(false);
    ShowNotifications({
      child: state.url,
      flashbar: state.flashbar,
      header: `Error creating new ${state.resource}:`,
      message: error.response?.data?.result || error.message,
      type: "error"
    });
  });
}

function ProductSettings({ state }) {
  const defaultState = {
    name: { value: "", error: false, required: true },
  };
  const [productSettingsData, setProductSettingsData] = useState(defaultState);

  useEffect(() => {
    state.setFormData(productSettingsData);
    const validateValues = Object.keys(productSettingsData).every(key => productSettingsData[key].error === false);
    const validateRequired = Object.keys(productSettingsData).every(key => productSettingsData[key].required === false || productSettingsData[key].value !== "");
    if (validateValues && validateRequired) {
      state.setValidated(true);
    }else {
      state.setValidated(false);
    }
  }, [productSettingsData]);

  const onChange = (attribute, value, isValid) => {
    const newState = { ...productSettingsData };
    newState[attribute]['value'] = value;
    newState[attribute]['error'] = isValid ? false : true;
    setProductSettingsData(newState);
  };

  const getErrorText = (field, errorMessage) => {
    return productSettingsData[field]['error'] ? errorMessage : undefined;
  };

  return (
    <Container
      id="new-product-form"
      header={
        <Header
          variant="h2"
          areaLabel={'Information about the product'}
        >
          Product Settings
        </Header>
      }
    >
      <SpaceBetween size="l">
        <FormField
          label="Product Name"
          stretch={true}
          description="The name of the product"
          errorText={getErrorText('name', 'Product name is required')}
          i18nStrings={{ errorIconAriaLabel: 'Error' }}
        >
          <Input
            value={productSettingsData.name.value}
            ariaRequired={true}
            placeholder="Product Name"
            onChange={({ detail: { value } }) => onChange('name', value, value.length > 0)}
          />
        </FormField>
      </SpaceBetween>
    </Container>
  );
}

function BaseFormContent({ resource, content, state}) {
  return (
    <form onSubmit={event => { event.preventDefault(); PostData(state)}}>
      <Form
        actions={
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={event => { event.preventDefault(); state.navigate("/products")}}>
              Cancel
            </Button>
            <Button
              variant="primary"
              disabled={!state.validated}
              loading={state.loading}
            >
              Create {resource}
            </Button>
          </SpaceBetween>
        }
      >
        {content}
      </Form>
    </form>
  );
}

export function FormContent({ resource, state }) {
  return (
    <BaseFormContent
      resource={resource}
      state={state}
      content={
        <SpaceBetween size="l">
          <ProductSettings state={state}/>
        </SpaceBetween>
      }
    />
  );
}

export function NewProductForm({ resource, url, flashbar }) {
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const state = {
    resource,
    url,
    validated,
    setValidated,
    navigate,
    formData,
    setFormData,
    loading,
    setLoading,
    flashbar,
  }
  return (
    <ContentLayout header={<NewResourceHeader resource={resource}/>}>
      <FormContent resource={resource} state={state}/>
    </ContentLayout>
  );
}
